import { DashboardOutlined } from "@ant-design/icons";
import { gaugeCore } from "./core/gauge";
import { defineWidget } from "../widgetDefinition";
import { gaugeSlots } from "../Slots";
import { gaugeDuplicate } from "../Duplication/gauge";
import { gaugeControlPanel } from "../ControlPanel/gauge";
import type { GaugeComponentSpec } from "../Processing/types";
import { GaugeWidget } from "../WidgetComponents/GaugeWidget";
import { GaugeInfo } from "../Info/gauge";
import { GaugeConfigurator } from "../AddWidgetModal/GaugeConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const gaugeDefinition = defineWidget<GaugeComponentSpec>({
  ...gaugeCore,
  type: "gauge",
  dynamic: { bindableSections: BINDABLE_SECTIONS.gauge },
  slots: gaugeSlots,
  duplicate: gaugeDuplicate,
  controlPanel: gaugeControlPanel,
  info: { Content: GaugeInfo },
  schema: ["display", "queryId", "scaleQueryId", "metric", "metricIdentifierType", "scale", "scale_color_mode", "segment_config", "gauge_builder_misc"],
  contractHash: "263jh36ves2",
  needsData: true,

  template: {
    label: "Gauge",
    description: "Speedometer dial for a single metric",
    icon: <DashboardOutlined />,
  },

  defaultLayout: { w: 4, h: 6, minW: 2, minH: 5 },

  gridComponent: ({ id }) => <GaugeWidget id={id} />,

  configurator: {
    modalTitle: "Configure Gauge",
    wide: true,
    Component: GaugeConfigurator as any,
  },
});
